/**
 * AxisRows — the gridlines and their tick labels, shared by every banded SVG chart
 * in the kit.
 *
 * One set of rows serves both axes: a chart with a second measure labels the same
 * lines on the right rather than drawing a second grid over the first. The baseline
 * row is a step darker than the rest — it is the zero the bars stand on, not another
 * gridline. Solid hairlines throughout; a dashed grid would compete with the dashed
 * target and divider rules, which in this app carry meaning.
 */

import type { Tokens } from './useTokens'

export default function AxisRows({ x1, x2, rows, rowY, left, right, t }: {
  x1: number
  x2: number
  rows: number
  rowY: (row: number) => number
  left: (row: number) => string
  right?: (row: number) => string
  t: Tokens
}) {
  return (
    <>
      {Array.from({ length: rows + 1 }, (_, r) => (
        <g key={`row${r}`}>
          <line x1={x1} x2={x2} y1={rowY(r)} y2={rowY(r)} stroke={r === 0 ? t.line : t.line2} strokeWidth={1} />
          <text x={x1 - 9} y={rowY(r) + 3.5} textAnchor="end" fill={t.mut2} fontSize={10} fontFamily="JetBrains Mono">
            {left(r)}
          </text>
          {right && (
            <text x={x2 + 9} y={rowY(r) + 3.5} fill={t.mut2} fontSize={10} fontFamily="JetBrains Mono">
              {right(r)}
            </text>
          )}
        </g>
      ))}
    </>
  )
}
